import React, { useState, useEffect, useContext } from "react";
import Select from "../../component/material/select/Select";
import VerticalBarChart from "./charts/VerticalBarChart";
import * as executiveApi from "../../service/executiveApi";
import * as publicApi from "../../service/publicApi";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import { HashLoader } from "react-spinners";
import styles from "./styleProvider.module.css";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import { FaFileAlt, FaUser, FaUsers } from "react-icons/fa";

function AggregateResult() {
const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [chartDataList, setChartDataList] = useState([]);

  const [healthAreaId, setHealthAreaId] = useState("");
  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");

  const [healthAreaList, setHealthAreaList] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  const [staffAmount, setStaffAmount] = useState(0);
  const [patientAmount, setPatientAmount] = useState(0);
  const [labAmount, setLabAmount] = useState(0);
  const [transactionAmount, setTransactionAmount] = useState("");

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    let res = await executiveApi.getAnalytic();
    setLoading(false);
    if (res?.data?.code === 200) {
      const list = res.data.analytic_list;
      setHealthAreaList(
        list.sort((a, b) => parseFloat(a.id) - parseFloat(b.id))
            .map(item => ({ key: item.id, value: item.name }))
      );
      setTransactionAmount(res.data.transaction_amount);
      updateSummary(list);
      getChartData(list);
    } else {
      handleApiError(res);
    }
  };

  const handleHealthAreaChange = async (id) => {
    setHealthAreaId(id);
    setProvinceId(""); 
    setDistrictId(""); 
    setProvinceList([]);
    setDistrictList([]);

    if (id === "") {
      fetchInitialData();
      return;
    } else {
      let res = await publicApi.getProvinceList(id);
      if (res?.data?.code === 200) {
        const list = res.data.province_list;
        setProvinceList(list.map(item => ({ key: item.province_id, value: item.province_name })));
      }
    }

    setLoading(true);
    let res = await executiveApi.getAnalytic({ health_area: id });
    setLoading(false);
    if (res?.data?.code === 200) {
      const list = res.data.analytic_list;
      updateSummary(list);
      getChartData(list);
    } else {
      handleApiError(res);
    }
  };

  const handleProvinceChange = async (id) => {
    setProvinceId(id);
    setDistrictId(""); 
    setDistrictList([]);

    if (id === "") {
      handleHealthAreaChange(healthAreaId);
      return;
    } else {
      let res = await publicApi.getDistrictList(id);
      if (res?.data?.code === 200) {
        const list = res.data.district_list;
        setDistrictList(list.map(item => ({ key: item.district_id, value: item.district_name })));
      }
    }

    setLoading(true);
    let res = await executiveApi.getAnalytic({ province_id: id });
    setLoading(false);
    if (res?.data?.code === 200) {
      const list = res.data.analytic_list;
      updateSummary(list);
      getChartData(list);
    } else {
      handleApiError(res);
    }
  };

  const handleDistrictChange = async (id) => {
    setDistrictId(id);
    if (id === "") {
      handleProvinceChange(provinceId);
      return;
    }

    setLoading(true);
    let res = await executiveApi.getAnalytic({ district_id: id });
    setLoading(false);
    if (res?.data?.code === 200) {
      const list = res.data.analytic_list;
      updateSummary(list);
      getChartData(list);
    } else {
      handleApiError(res);
    }
  };

  const updateSummary = (list) => {
    setStaffAmount(list.reduce((sum, obj) => (obj.staff_amount || 0) + sum, 0));
    setPatientAmount(list.reduce((sum, obj) => (obj.patient_amount || 0) + sum, 0));
    setLabAmount(list.reduce((sum, obj) => (obj.lab_amount || 0) + sum, 0));
  };

  const getChartData = (data) => {
    setChartDataList(data.map(item => ({
      name: item.name,
      staff_amount: item.staff_amount,
      patient_amount: item.patient_amount,
      lab_amount: item.lab_amount,
    })));
  };

  const handleApiError = (res) => {
    if (res?.data?.code === 403) {
      navigate(RedirectCode400());
    } else {
      setIsMessage({ type: "warning", data: res?.data?.message || "เกิดข้อผิดพลาด" });
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ผลสรุป", url: "/manager/aggregateResult" },
    { name: "สรุปจำนวนการเข้าใช้งาน", url: "" },
  ];

  return (
    <>
      {loading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/50">
          <HashLoader
            loading={loading}
            color="#FF9768"
            size={60}
          />
        </div>
      )}

      <div className={styles.page}>
        <div className="mt-[10px]">
          <Breadcrumb pathItems={pathItems} />
        </div>
        <div className={styles.sidepage}>
          <p className="text-center text-2xl font-bold lg:!mt-[20px] mt-[70px] font-['Prompt-SemiBold']">
            ผลสรุป
          </p>

          <div
            // className="items-center w-full pb-5 text-center"
            className={styles.menuTab}
          >
            <div className={styles.tabActive}>สรุปจำนวนการเข้าใช้งาน</div>
            <div
              className={styles.tab}
              onClick={(e) => navigate("/manager/geneResult")}
            >
              สรุปผลการตรวจยีนทั้งหมด
            </div>
            <div
              className={styles.tab}
              onClick={(e) => navigate("/manager/inspectionRateMap")}
            >
              แผนที่ห้องปฏิบัติการที่มีในระบบ
            </div>
          </div>

          {/* <div className="relative">
          <div className="absolute top-0 right-0 mx-6 my-6">
            <div className="flex items-baseline">
              <p className="text-sm text-[#000000] mr-4">จำนวนธุรกรรมต่อวัน</p>
              <p className="text-xl md:text-sm font-bold">
                {transactionAmount}
              </p>
            </div>
          </div>
        </div> */}

          <p className="text-left text-2xl font-bold my-4 font-['Prompt-SemiBold']">
            สรุปจำนวนการเข้าใช้งาน
          </p>

          <div className={styles.select}>
            <Select
              placeholder="เลือกเขตสุขภาพ"
              label="เลือกเขตสุขภาพ"
              value={healthAreaId}
              setValue={(e) => handleHealthAreaChange(e)}
              list={healthAreaList}
              style={{ borderRadius: "5px" }}
            />

            <Select
              placeholder="เลือกจังหวัด"
              label="เลือกจังหวัด"
              value={provinceId}
              disabled={healthAreaId === ""}
              setValue={(e) => handleProvinceChange(e)}
              list={provinceList}
              style={{ borderRadius: "5px" }}
            />

            <Select
              placeholder="เลือกอำเภอ"
              label="เลือกอำเภอ"
              value={districtId}
              disabled={provinceId === ""}
              setValue={(e) => handleDistrictChange(e)}
              list={districtList}
              style={{ borderRadius: "5px" }}
            />
          </div>

          <div className={styles.select}>
            <div className={styles.card}>
              <div className="flex justify-center items-center">
                <div className="w-12 h-12 md:w-6 md:h-6 bg-[#e7e5fd] rounded mr-4 py-4 px-3 flex justify-center">
                  <FaUsers style={{ width: "20px" }} color="#786fef" />
                </div>
                <div className="text-xl md:text-sm font-bold">
                  <p> {staffAmount}</p>
                  <p className="text-sm text-[#a7a7a7]">
                    จำนวนเจ้าหน้าที่ผู้ให้บริการ
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.card}>
              <div className="flex justify-center items-center">
                <div className="w-12 h-12 md:w-6 md:h-6 bg-[#d4f7fc] rounded mr-4 py-4 px-3 flex justify-center">
                  <FaUser style={{ width: "20px" }} color="#29c9e5" />
                </div>
                <div className="text-xl md:text-sm font-bold">
                  <p> {patientAmount}</p>
                  <p className="text-sm text-[#a7a7a7]">
                    จำนวนประชาชนผู้รับบริการ
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.card}>
              <div className="flex justify-center items-center">
                <div className="w-12 h-12 md:w-6 md:h-6 bg-[#daf6e6] rounded mr-4 py-4 px-3 flex justify-center">
                  <FaFileAlt style={{ width: "20px" }} color="#28c670" />
                </div>
                <div className="text-xl md:text-sm font-bold">
                  <p> {labAmount}</p>
                  <p className="text-sm text-[#a7a7a7]">จำนวนข้อมูลในระบบ</p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full overflow-auto">
            <div className={styles.Var}>
              <VerticalBarChart data={chartDataList} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AggregateResult;
